import React from "react"
import { CONSTANTS } from "../../utils/const"

const CommonHero = ({ data, customClasses = {} }) => {
  const handleNavigate = () => {
    window.open(CONSTANTS.MEETING_LINK, "_blank")
  }
  return (
    <section className="md:px-20 md:pe-10 xll:pe-20 px-6 bg-white-200 items-center flex flex-col gap-8 md:flex-row py-12 md:py-[6.75rem]">
      <div className="flex basis-full md:basis-10/12 xl:basis-9/12 flex-col gap-4 md:gap-10 w-full">
        <h1
          className={`text-gray-100 text-[3.7rem] md:text-7xl  lg:text-8xl tracking-[-3.36px] lg:tracking-tight-7% ${customClasses.heading ? customClasses.heading : ""}`}
        >
          {data.label}
        </h1>
        <p
          className={`md:text-[1.125rem] text-black-300  text-[1rem]  ${customClasses.text ? customClasses.text : ""}`}
        >
          {data.description}
        </p>

        <div className=" ">
          <button
            onClick={handleNavigate}
            className="border transition-all border-blue-100 hover:border-none hover:bg-blue-100 text-blue-100 hover:text-white-200  rounded-full text-xl tracking-tight-2%  font-normal py-2 md:py-4 px-4 min-w-[12rem] md:min-w-[15.5rem]  h-14 md:h-16 "
          >
            {data.buttonText}
          </button>
        </div>
      </div>
    </section>
  )
}

export default CommonHero
